<template>
  <div class="modal_wrap system ic_commonModal" :class="{ on: show }">
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">정렬 선택</h1>
        </div>
        <div class="modal_con">
          <!-- <div class="modal_txt">
            <ul v-for="(item, index) in area" :key="index">
              <li>{{ item }}</li>
            </ul>
          </div> -->
          <div class="form_wrap">
            <div class="check_table" data-columns="">
              <label v-for="(item, index) in sort" :key="index"
                ><input
                  type="radio"
                  name="listSort"
                  v-model="sortIndex"
                  :value="index"
                /><span>{{ item }}</span></label
              >
            </div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn" @click="close(false)">
              닫기
            </button>
            <button class="btn2" @click="close(true)">
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'listSortModal',
  props: {
    show: Boolean,
  },
  data() {
    return {
      sort: [
        '총 납부액 낮은 순',
        '지원금 높은 순',
        '상담 많은 순',
        '평가 높은 순',
      ],
      sortVal: [
        // 'CREATED_AT_ASC',
        // 'CREATED_AT_DESC',
        'PRICE_ASC',
        'SUPPORT_DESC',
        'CHAT_DESC',
        'RATE_DESC',
      ],
      sortIndex: 0,
      selectSortTxt: '',
      selectSortVal: '',
    };
  },
  methods: {
    close(dataType) {
      if (dataType) {
        this.selectSortTxt = this.sort[this.sortIndex];
        this.selectSortVal = this.sortVal[this.sortIndex];
      }
      this.$emit('close', dataType);
    },
  },
};
</script>
